/* ==========================================================================
   PHAB SPORTS — theme.js (JavaScript puro, sem dependências)
   ========================================================================== */
(() => {
  'use strict';

  const P = window.PHAB || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const on = (el, ev, fn, opt) => el && el.addEventListener(ev, fn, opt);

  /* ---------------- utilidades ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || P.moneyFormat || '${{amount}}';
    const num = (n, prec, thou, dec) => {
      thou = thou === undefined ? ',' : thou;
      dec = dec === undefined ? '.' : dec;
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(prec);
      const parts = n.split('.');
      const d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return d + (parts[1] ? dec + parts[1] : '');
    };
    const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    let v = '';
    switch (m && m[1]) {
      case 'amount_no_decimals': v = num(cents, 0); break;
      case 'amount_with_comma_separator': v = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = num(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = num(cents, 2, "'", '.'); break;
      default: v = num(cents, 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  let lockCount = 0;
  const lock = () => { lockCount++; document.body.classList.add('is-locked'); };
  const unlock = () => { lockCount = Math.max(0, lockCount - 1); if (!lockCount) document.body.classList.remove('is-locked'); };

  function toast(msg) {
    const t = $('[data-toast]');
    if (!t) return alert(msg);
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(t._t);
    t._t = setTimeout(() => { t.hidden = true; }, 3200);
  }

  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

  /* ==========================================================================
     BARRA DE OFERTA: ofertas girando + contador
     ========================================================================== */
  function initOfferBar() {
    $$('[data-offer-bar]').forEach((bar) => {
      const offers = $$('.ob__offer', bar);
      const secs = (parseInt(bar.dataset.rotate, 10) || 3) * 1000;
      if (offers.length > 1) {
        let i = 0;
        setInterval(() => {
          const cur = offers[i];
          cur.classList.remove('is-on');
          cur.classList.add('is-out');
          setTimeout(() => cur.classList.remove('is-out'), 400);
          i = (i + 1) % offers.length;
          offers[i].classList.add('is-on');
        }, secs);
      }

      const clock = $('[data-ob-clock]', bar);
      const mode = bar.dataset.mode;
      if (!clock || mode === 'off') return;
      const tz = parseFloat(bar.dataset.tz || '0');
      const [ch, cm] = (bar.dataset.cutoff || '15:0').split(':').map((n) => parseInt(n, 10) || 0);
      const el = { d: $('[data-ob-d]', clock), h: $('[data-ob-h]', clock), m: $('[data-ob-m]', clock), s: $('[data-ob-s]', clock), dc: $('[data-ob-dcell]', clock), l1: $('[data-ob-lbl]', clock), l2: $('[data-ob-lbl2]', clock) };
      const pad = (n) => String(n).padStart(2, '0');

      // "agora" no fuso escolhido, representado como Date UTC
      const nowTz = () => new Date(Date.now() + tz * 3600000);

      function targetDaily() {
        const n = nowTz();
        const t = new Date(Date.UTC(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate(), ch, cm, 0));
        let late = false;
        const isWeekend = (d) => d.getUTCDay() === 0 || d.getUTCDay() === 6;
        if (n >= t || isWeekend(n)) {
          late = true;
          do { t.setUTCDate(t.getUTCDate() + 1); } while (isWeekend(t));
        }
        return { ms: t - n, late };
      }
      let deadline = null;
      if (mode === 'deadline' && bar.dataset.deadline) {
        const m = bar.dataset.deadline.trim().match(/(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
        if (m) deadline = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 23), +(m[5] || 59)) - tz * 3600000;
      }

      function tick() {
        let ms; let late = false;
        if (mode === 'deadline') {
          if (!deadline) { clock.hidden = true; return; }
          ms = deadline - Date.now();
          if (ms <= 0) { clock.hidden = true; return; }
        } else {
          const r = targetDaily(); ms = r.ms; late = r.late;
        }
        const s = Math.floor(ms / 1000);
        const d = Math.floor(s / 86400);
        const h = Math.floor((s % 86400) / 3600);
        const m = Math.floor((s % 3600) / 60);
        const sec = s % 60;
        if (el.dc) el.dc.hidden = d === 0;
        if (el.d) el.d.textContent = pad(d);
        el.h.textContent = pad(d && mode !== 'deadline' ? h + d * 24 : h);
        el.m.textContent = pad(m);
        el.s.textContent = pad(sec);
        if (mode === 'daily') {
          el.l1.textContent = late ? bar.dataset.lblTomorrow : bar.dataset.lblToday;
          el.l2.textContent = late ? bar.dataset.lbl2Tomorrow : bar.dataset.lbl2Today;
        }
        clock.hidden = false;
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ==========================================================================
     BARRA ROLANTE DO TOPO: botão pausar/tocar
     ========================================================================== */
  function initTicker() {
    $$('[data-ticker]').forEach((tk) => {
      const btn = $('[data-ticker-toggle]', tk);
      if (!btn || btn._b) return;
      btn._b = true;
      on(btn, 'click', () => {
        const paused = tk.classList.toggle('is-paused');
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.setAttribute('aria-label', paused ? 'Play' : 'Pause');
      });
    });
  }

  /* ==========================================================================
     CABEÇALHO: mega menu, menu mobile, busca
     ========================================================================== */
  function initHeader() {
    // mega: indicador "More below" quando há rolagem
    $$('[data-mega-item]').forEach((item) => {
      const mega = $('[data-mega]', item);
      const scroller = $('[data-mega-scroll]', item);
      let tOpen; let tClose;
      const check = () => {
        if (!scroller) return;
        const more = scroller.scrollHeight - scroller.clientHeight - scroller.scrollTop > 16;
        mega.classList.toggle('has-more', more);
      };
      on(item, 'mouseenter', () => { clearTimeout(tClose); tOpen = setTimeout(() => { item.classList.add('is-open'); check(); }, 60); });
      on(item, 'mouseleave', () => { clearTimeout(tOpen); tClose = setTimeout(() => item.classList.remove('is-open'), 120); });
      on(scroller, 'scroll', check, { passive: true });
      on($('.nav__link', item), 'focus', check);
    });

    // se os itens do menu não couberem na largura, usa o menu hambúrguer (nunca sobrepõe o logo/busca)
    const hdr = $('[data-header]');
    const nav = hdr && $('.nav', hdr);
    if (nav) {
      const fit = () => {
        hdr.classList.remove('is-compact');
        if (getComputedStyle(nav).display === 'none') return;
        if (nav.scrollWidth > nav.clientWidth + 2) hdr.classList.add('is-compact');
      };
      fit();
      on(window, 'resize', debounce(fit, 120));
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    }

    // busca vazia não envia: só abre/foca o campo (lupa compacta nos notebooks)
    $$('.hdr__search, .msearch').forEach((f) => on(f, 'submit', (e) => {
      const q = $('input[name="q"]', f);
      if (q && !q.value.trim()) { e.preventDefault(); q.focus(); }
    }));

    // menu mobile
    const mm = $('[data-mmenu]');
    const openBtn = $('[data-mmenu-open]');
    const open = () => { mm.classList.add('is-open'); mm.setAttribute('aria-hidden', 'false'); openBtn && openBtn.setAttribute('aria-expanded', 'true'); lock(); };
    const close = () => { mm.classList.remove('is-open'); mm.setAttribute('aria-hidden', 'true'); openBtn && openBtn.setAttribute('aria-expanded', 'false'); unlock(); };
    if (mm) {
      on(openBtn, 'click', open);
      $$('[data-mmenu-close]', mm).forEach((b) => on(b, 'click', close));
      $$('[data-mm-toggle]', mm).forEach((btn) => {
        on(btn, 'click', () => {
          const sub = btn.nextElementSibling;
          const exp = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', exp ? 'false' : 'true');
          if (sub) sub.hidden = exp;
        });
      });
      on(document, 'keydown', (e) => { if (e.key === 'Escape' && mm.classList.contains('is-open')) close(); });
    }

    // placeholder digitando (busca do celular)
    const typing = $('[data-typing]');
    const phrases = (P.searchPhrases || []).map((s) => s.trim()).filter(Boolean);
    if (typing && phrases.length > 1) {
      let pi = 0; let ci = 0; let del = false;
      const step = () => {
        if (document.activeElement === typing || typing.value) { setTimeout(step, 800); return; }
        const ph = phrases[pi];
        ci += del ? -1 : 1;
        typing.setAttribute('placeholder', ph.slice(0, ci));
        let wait = del ? 35 : 70;
        if (!del && ci >= ph.length) { del = true; wait = 1600; }
        else if (del && ci <= 0) { del = false; pi = (pi + 1) % phrases.length; wait = 300; }
        setTimeout(step, wait);
      };
      setTimeout(step, 1200);
    }

    // busca preditiva
    if (P.predictive) {
      $$('[data-predictive]').forEach((form) => {
        const input = $('input[name="q"]', form);
        const box = $('[data-predictive-results]', form);
        if (!input || !box) return;
        const render = (q, products) => {
          if (!q) { box.hidden = true; return; }
          if (!products.length) { box.innerHTML = '<p class="predictive__empty">No results for “' + escapeHtml(q) + '”</p>'; box.hidden = false; return; }
          box.innerHTML = products.map((p) => {
            const price = formatMoney(Math.round(parseFloat(p.price) * 100));
            const img = p.image ? '<img src="' + p.image + (p.image.includes('?') ? '&' : '?') + 'width=120" alt="" width="52" height="52" loading="lazy">' : '';
            return '<a class="predictive__item" href="' + p.url + '">' + img + '<span><span class="predictive__name">' + escapeHtml(p.title) + '</span><br><span class="predictive__price">' + price + '</span></span></a>';
          }).join('') + '<a class="predictive__all" href="' + P.routes.search + '?type=product&q=' + encodeURIComponent(q) + '">View all results</a>';
          box.hidden = false;
        };
        const run = debounce(async () => {
          const q = input.value.trim();
          if (q.length < 2) { box.hidden = true; return; }
          try {
            const r = await fetch(P.routes.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last');
            const j = await r.json();
            render(q, (j.resources && j.resources.results && j.resources.results.products) || []);
          } catch (e) { box.hidden = true; }
        }, 250);
        on(input, 'input', run);
        on(input, 'focus', () => { if (box.innerHTML && input.value.trim().length > 1) box.hidden = false; });
        on(document, 'click', (e) => { if (!form.contains(e.target)) box.hidden = true; });
      });
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  /* ==========================================================================
     CARROSSÉIS (setas + barra de progresso)
     ========================================================================== */
  function initCarousels(root = document) {
    $$('[data-car]', root).forEach((car) => {
      if (car._car) return;
      car._car = true;
      const track = $('[data-car-track]', car);
      if (!track) return;
      const prev = $('[data-car-prev]', car);
      const next = $('[data-car-next]', car);
      const prog = $('[data-car-prog]', car);
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        const pct = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        if (prog) {
          prog.style.width = Math.max(8, pct * 100) + '%';
          const pos = max > 0 ? track.scrollLeft / max : 0;
          prog.style.transform = 'translateX(' + (pos * (1 / pct - 1) * 100) + '%)';
        }
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= max - 4;
        const ctr = prev && prev.closest('.car__controls');
        if (ctr) ctr.style.visibility = max <= 4 ? 'hidden' : '';
      };
      const page = (dir) => {
        const item = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 14;
        const w = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
        const n = Math.max(1, Math.floor((track.clientWidth + gap) / w));
        track.scrollBy({ left: dir * n * w, behavior: 'smooth' });
      };
      on(prev, 'click', () => page(-1));
      on(next, 'click', () => page(1));
      on(track, 'scroll', update, { passive: true });
      on(window, 'resize', debounce(update, 150));
      update();
      setTimeout(update, 600);
    });
  }

  /* ==========================================================================
     BANNER PRINCIPAL
     ========================================================================== */
  function initHero() {
    $$('[data-hero]').forEach((hero) => {
      const track = $('[data-hero-track]', hero);
      const dots = $$('[data-hero-dot]', hero);
      if (!track || dots.length < 2) return;
      let idx = 0;
      const go = (i) => { idx = (i + dots.length) % dots.length; track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' }); };
      dots.forEach((d) => on(d, 'click', () => { go(+d.dataset.heroDot); restart(); }));
      on(track, 'scroll', debounce(() => {
        idx = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((d, i) => d.classList.toggle('is-on', i === idx));
      }, 60), { passive: true });
      let timer;
      const restart = () => {
        clearInterval(timer);
        if (hero.dataset.autoplay === 'true') timer = setInterval(() => go(idx + 1), (parseInt(hero.dataset.speed, 10) || 6) * 1000);
      };
      on(hero, 'mouseenter', () => clearInterval(timer));
      on(hero, 'mouseleave', restart);
      restart();
    });
  }

  /* ==========================================================================
     AVALIAÇÕES / VÍDEOS / VÍDEO FLUTUANTE
     ========================================================================== */
  function initReviews() {
    $$('[data-rv]').forEach((rv) => {
      const track = $('[data-rv-track]', rv);
      const step = () => { const s = track.firstElementChild; return s ? s.getBoundingClientRect().width + 16 : 300; };
      on($('[data-rv-prev]', rv), 'click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      on($('[data-rv-next]', rv), 'click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    });
    $$('[data-vr-open]').forEach((btn) => {
      on(btn, 'click', () => {
        const dlg = document.getElementById(btn.dataset.vrOpen);
        if (!dlg || !dlg.showModal) return;
        dlg.showModal();
        const v = $('video', dlg); if (v) { v.currentTime = 0; v.play().catch(() => {}); }
      });
    });
    $$('.vr__modal').forEach((dlg) => {
      const stop = () => { const v = $('video', dlg); if (v) v.pause(); };
      on(dlg, 'close', stop);
      on(dlg, 'click', (e) => { if (e.target === dlg) dlg.close(); });
      on($('[data-vr-close]', dlg), 'click', () => dlg.close());
    });
    const fv = $('[data-fvid]');
    if (fv) {
      const v = $('video', fv);
      on($('[data-fvid-close]', fv), 'click', (e) => { e.stopPropagation(); fv.remove(); });
      on($('[data-fvid-sound]', fv), 'click', (e) => {
        e.stopPropagation();
        if (!v) return;
        v.muted = !v.muted;
        fv.classList.toggle('is-big', !v.muted);
        if (!v.muted) { v.currentTime = 0; v.play().catch(() => {}); }
      });
    }
  }

  /* ==========================================================================
     CARRINHO
     ========================================================================== */
  const Cart = {
    drawer: null,
    init() {
      this.drawer = $('[data-cart-drawer]');
      on(document, 'click', (e) => {
        const openBtn = e.target.closest('[data-cart-open]');
        if (openBtn && P.cartType === 'drawer' && this.drawer && !document.body.classList.contains('template-cart')) {
          e.preventDefault(); this.open();
        }
        if (e.target.closest('[data-cart-close]')) { e.preventDefault(); this.close(); }
      });
      on(document, 'keydown', (e) => { if (e.key === 'Escape' && this.drawer && this.drawer.classList.contains('is-open')) this.close(); });
      this.bindLines(document);
    },
    open() { if (!this.drawer) return; this.drawer.classList.add('is-open'); this.drawer.setAttribute('aria-hidden', 'false'); lock(); },
    close() { if (!this.drawer) return; this.drawer.classList.remove('is-open'); this.drawer.setAttribute('aria-hidden', 'true'); unlock(); },
    sectionIds() {
      const ids = [];
      if ($('[data-cart-inner]')) ids.push('cart-drawer');
      const page = $('[data-cart-inner-page]');
      if (page) { const s = page.closest('.shopify-section'); if (s) ids.push(s.id.replace('shopify-section-', '')); }
      return ids;
    },
    render(sections) {
      if (!sections) return;
      Object.keys(sections).forEach((id) => {
        const html = sections[id];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        if (id === 'cart-drawer') {
          const src = $('[data-cart-inner]', doc); const dst = $('[data-cart-inner]');
          if (src && dst) dst.innerHTML = src.innerHTML;
        } else {
          const src = $('[data-cart-inner-page]', doc); const dst = $('[data-cart-inner-page]');
          if (src && dst) dst.innerHTML = src.innerHTML;
        }
      });
      this.bindLines(document);
    },
    setCount(n) {
      $$('[data-cart-count]').forEach((b) => { b.textContent = n; b.hidden = !n; });
    },
    async refresh() {
      const ids = this.sectionIds();
      try {
        const r = await fetch(P.routes.root + '?sections=' + ids.join(','));
        this.render(await r.json());
        const c = await (await fetch(P.routes.cart + '.js')).json();
        this.setCount(c.item_count);
      } catch (e) { /* silencioso */ }
    },
    async update(updates) {
      const boxes = $$('[data-cart-inner], [data-cart-inner-page]');
      boxes.forEach((b) => b.classList.add('cart-loading'));
      try {
        const r = await fetch(P.routes.cartUpdate + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates, sections: this.sectionIds(), sections_url: location.pathname })
        });
        const j = await r.json();
        if (j.status && j.description) toast(j.description);
        this.render(j.sections);
        if (typeof j.item_count === 'number') this.setCount(j.item_count);
      } catch (e) { toast(P.strings.error); }
      boxes.forEach((b) => b.classList.remove('cart-loading'));
    },
    bindLines(root) {
      $$('[data-line]', root).forEach((line) => {
        if (line._b) return; line._b = true;
        const key = line.dataset.line;
        const children = (line.dataset.children || '').split(',').filter(Boolean);
        const input = $('[data-qty-input]', line);
        const set = (q) => {
          q = Math.max(0, parseInt(q, 10) || 0);
          const u = { [key]: q };
          children.forEach((c) => { u[c] = q; });
          this.update(u);
        };
        on($('[data-qty-minus]', line), 'click', () => set((+input.value || 1) - 1));
        on($('[data-qty-plus]', line), 'click', () => set((+input.value || 0) + 1));
        on(input, 'change', () => set(input.value));
        on($('[data-remove]', line), 'click', () => set(0));
      });
    },
    async add(items) {
      const ids = this.sectionIds();
      const r = await fetch(P.routes.cartAdd + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: ids, sections_url: location.pathname })
      });
      const j = await r.json();
      if (!r.ok || j.status) throw new Error(j.description || j.message || P.strings.error);
      if (P.cartType === 'page') { location.href = P.routes.cart; return; }
      this.render(j.sections);
      try { const c = await (await fetch(P.routes.cart + '.js')).json(); this.setCount(c.item_count); } catch (e) { /* */ }
      this.open();
    }
  };

  /* ==========================================================================
     PRODUTO
     ========================================================================== */
  function initProduct(root) {
    const form = $('[data-product-form]', root);
    if (!form) return;
    let variants = [];
    try { variants = JSON.parse(($('[data-variants]', root) || {}).textContent || '[]'); } catch (e) { variants = []; }
    // ordena pelo índice real da opção (a caixa de patches pode aparecer em outra posição na tela)
    const groups = $$('[data-opt]', root).sort((x, y) => (+x.dataset.optIndex) - (+y.dataset.optIndex));
    const idInput = $('input[data-variant-id]', root);
    const atc = $('[data-atc]', root);
    const atcText = $('[data-atc-text]', root);
    const atcLabel = atcText ? atcText.textContent : P.strings.addToCart;
    const custom = $('[data-custom]', root);
    const fallback = $('[data-opt-fallback]', root);
    const triggers = custom ? (custom.dataset.triggers || '').split('|').map((s) => s.trim()).filter(Boolean) : [];

    const selected = () => groups.map((g) => { const b = $('.opt__btn.is-on', g); return b ? b.dataset.value : null; });
    const findVariant = (opts) => variants.find((v) => v.options.every((o, i) => o === opts[i]));

    function markAvailability() {
      const sel = selected();
      groups.forEach((g, gi) => {
        $$('.opt__btn', g).forEach((b) => {
          const test = sel.slice(); test[gi] = b.dataset.value;
          const v = findVariant(test);
          b.classList.toggle('is-out', !v || !v.available);
        });
      });
    }

    function updatePrice(v) {
      const box = $('[data-price-box]', root);
      if (!box || !v) return;
      const now = $('[data-price-now]', box);
      const was = $('[data-price-was]', box);
      const off = $('[data-price-off]', box);
      const priceEl = $('.price', box);
      if (now) now.textContent = formatMoney(v.price);
      const sale = v.compare > v.price;
      if (priceEl) priceEl.classList.toggle('price--sale', sale);
      if (was) { was.hidden = !sale; if (sale) was.textContent = formatMoney(v.compare); }
      if (off) {
        off.hidden = !sale;
        if (sale) {
          const pct = Math.round(((v.compare - v.price) / v.compare) * 100);
          const fmt = priceEl ? priceEl.dataset.format : 'percent';
          $('i', off).textContent = fmt === 'save_percent' ? 'Save ' + pct + '%' : fmt === 'save_amount' ? 'Save ' + formatMoney(v.compare - v.price) : '-' + pct + '%';
        }
      }
      const sp = $('[data-sticky-price]'); if (sp) sp.textContent = formatMoney(v.price);
    }

    function customActive() {
      if (!custom) return false;
      if (fallback) { const b = $('.opt__btn.is-on', fallback); return !!(b && b.hasAttribute('data-trigger')); }
      const g = $('[data-opt-custom]', root);
      if (!g) return false;
      const b = $('.opt__btn.is-on', g);
      return !!(b && triggers.includes(b.dataset.value.trim().toLowerCase()));
    }

    function toggleCustom() {
      if (!custom) return;
      const act = customActive();
      custom.hidden = !act;
      $$('input', custom).forEach((i) => { i.disabled = !act; });
      if (!act) custom.classList.remove('has-error');
    }

    function onVariantChange() {
      const v = findVariant(selected());
      markAvailability();
      toggleCustom();
      if (!v) {
        if (atc) atc.disabled = true;
        if (atcText) atcText.textContent = P.strings.unavailable;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (atc) atc.disabled = !v.available;
      if (atcText) atcText.textContent = v.available ? atcLabel : P.strings.soldOut;
      updatePrice(v);
      if (v.media) showMedia(v.media);
      if (root.dataset.url && history.replaceState) {
        const u = new URL(location.href); u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
      const pt = $('shopify-payment-terms', root);
      if (pt) pt.setAttribute('variant-id', v.id);
    }

    groups.concat(fallback ? [fallback] : []).forEach((g) => {
      $$('.opt__btn', g).forEach((b) => {
        on(b, 'click', () => {
          $$('.opt__btn', g).forEach((x) => { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
          b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true');
          const lab = $('[data-opt-selected]', g); if (lab) lab.textContent = b.dataset.value;
          if (g === fallback) toggleCustom(); else onVariantChange();
        });
      });
    });
    markAvailability();
    toggleCustom();

    /* ---------- galeria ---------- */
    const stage = $('[data-gal-stage]', root);
    const thumbs = $$('[data-gal-thumb]', root);
    const isMobile = () => window.matchMedia('(max-width: 989px)').matches;
    function setActiveThumb(i) {
      thumbs.forEach((t, ti) => t.classList.toggle('is-active', ti === i));
      const t = thumbs[i]; if (t && t.parentElement) t.parentElement.scrollTo({ left: t.offsetLeft - 20, behavior: 'smooth' });
    }
    function showMedia(mediaId) {
      if (!stage) return;
      const item = $('[data-media-id="' + mediaId + '"]', stage);
      if (!item) return;
      if (isMobile()) {
        stage.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      } else if (item !== stage.firstElementChild) {
        stage.insertBefore(item, stage.firstElementChild);
      }
    }
    if (stage) {
      thumbs.forEach((t) => on(t, 'click', () => {
        const i = +t.dataset.galThumb;
        const it = $$('.gal__item', stage)[i];
        if (it) stage.scrollTo({ left: it.offsetLeft, behavior: 'smooth' });
        setActiveThumb(i);
      }));
      on(stage, 'scroll', debounce(() => {
        if (!isMobile()) return;
        const i = Math.round(stage.scrollLeft / stage.clientWidth);
        const it = $$('.gal__item', stage)[i];
        setActiveThumb(it ? +it.dataset.index : i);
      }, 60), { passive: true });
      on($('[data-gal-prev]', root), 'click', () => stage.scrollBy({ left: -stage.clientWidth, behavior: 'smooth' }));
      on($('[data-gal-next]', root), 'click', () => stage.scrollBy({ left: stage.clientWidth, behavior: 'smooth' }));
    }

    /* ---------- personalização (nome e número) ---------- */
    if (custom) {
      const inName = $('[data-cz-input-name]', custom);
      const inNum = $('[data-cz-input-num]', custom);
      const err = $('[data-cz-err]', custom);
      const clean = () => {
        if (inNum) inNum.value = inNum.value.replace(/\D/g, '');
        if ((inName && inName.value.trim()) || (inNum && inNum.value)) { custom.classList.remove('has-error'); if (err) err.hidden = true; }
      };
      on(inName, 'input', clean);
      on(inNum, 'input', clean);
    }

    /* ---------- patches: vêm da seção "Patches" do modelo de produto ---------- */
    mountPatches(root);
    mountReviews(root);

    /* ---------- adicionar ao carrinho ---------- */
    on(form, 'submit', async (e) => {
      e.preventDefault();
      if (atc && atc.disabled) return;
      if (custom && !custom.hidden) {
        const n = ($('[data-cz-input-name]', custom) || {}).value || '';
        const num = ($('[data-cz-input-num]', custom) || {}).value || '';
        if (!n.trim() && !num.trim()) {
          custom.classList.add('has-error');
          const err = $('[data-cz-err]', custom); if (err) err.hidden = false;
          custom.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
      }
      // propriedades da linha (aparecem no checkout e no pedido do Admin)
      const fd = new FormData(form);
      const props = {};
      for (const [k, v] of fd.entries()) {
        const m = k.match(/^properties\[(.+)\]$/);
        if (m && String(v).trim() !== '') props[m[1]] = String(v).trim().toUpperCase();
      }
      const qty = parseInt(fd.get('quantity'), 10) || 1;
      const main = { id: parseInt(idInput.value, 10), quantity: qty, properties: props };
      const items = [main];
      // patches: cada um entra como item separado, ligado à camisa pelo código _uid/_for
      const patches = $('[data-patches]', root);
      const checked = patches ? $$('[data-patch-check]:checked', patches) : [];
      if (checked.length) {
        const uid = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
        main.properties._uid = uid;
        const title = (root.querySelector('.pdp__title') || {}).textContent || '';
        const size = (selected()[0] || '');
        const forText = (title.trim() + (size ? ' (' + size + ')' : '')).toUpperCase();
        const propName = patches.dataset.prop || 'Patch for';
        checked.forEach((c) => {
          const row = c.closest('[data-patch]');
          items.push({ id: parseInt(row.dataset.patchVariant, 10), quantity: qty, properties: { [propName]: forText, Placement: row.dataset.placement || '', _for: uid } });
        });
      }
      if (atc) { atc.classList.add('is-loading'); if (atcText) atcText.textContent = P.strings.adding; }
      try {
        await Cart.add(items);
      } catch (err) {
        toast(err.message || P.strings.error);
      }
      if (atc) { atc.classList.remove('is-loading'); if (atcText) atcText.textContent = atc.disabled ? P.strings.soldOut : atcLabel; }
    });

    /* ---------- barra fixa (celular) ---------- */
    const bar = $('[data-stickybar]');
    if (bar && atc && 'IntersectionObserver' in window) {
      bar.hidden = false;
      new IntersectionObserver((ents) => {
        ents.forEach((en) => {
          const past = !en.isIntersecting && en.boundingClientRect.top < 0;
          bar.classList.toggle('is-on', past);
        });
      }).observe(atc);
      on($('[data-sticky-atc]', bar), 'click', () => {
        if (custom && !custom.hidden) { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        if (form.requestSubmit) form.requestSubmit(); else atc.click();
      });
    }

    /* ---------- data de envio ---------- */
    const sb = $('[data-shipby]', root.parentElement || document);
    if (sb) {
      const d = new Date();
      let n = parseInt(P.shipDays, 10) || 0;
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
      sb.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    }
  }

  /* ==========================================================================
     PATCHES
     As regras ficam na seção "Patches" (sections/patch-rules.liquid), que gera a
     caixa dentro de um <template>. Aqui ela é colocada no lugar reservado do
     formulário do produto ([data-patch-slot]).
     ========================================================================== */
  function mountPatches(root) {
    const slot = $('[data-patch-slot]', root);
    if (!slot) return;
    const src = document.querySelector('template[data-patch-source]');
    slot.innerHTML = '';
    if (!src) return;
    slot.appendChild(src.content.cloneNode(true));
    const box = $('[data-patches]', slot);
    if (box) initPatches(box);
  }

  function initPatches(box) {
    const panel = $('[data-patches-panel]', box);
    const trig = $('[data-patches-toggle]', box);
    const sub = $('[data-patches-sub]', box);
    const max = parseInt(box.dataset.max, 10) || 99;
    on(trig, 'click', () => {
      const open = panel.hidden;
      panel.hidden = !open;
      box.classList.toggle('is-open', open);
      trig.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    const apply = () => {
      $$('[data-patch-grp]', box).forEach((g) => {
        const checks = $$('[data-patch-check]', g);
        const n = checks.filter((c) => c.checked).length;
        checks.forEach((c) => {
          const row = c.closest('[data-patch]');
          const locked = n >= max && !c.checked;
          c.disabled = locked;
          row.classList.toggle('is-locked', locked);
          row.classList.toggle('is-checked', c.checked);
        });
      });
      const total = $$('[data-patch-check]:checked', box).length;
      if (sub) sub.textContent = total ? (P.strings.patchSelected || '[n] selected').replace('[n]', total) : sub.dataset.initial;
    };
    on(box, 'change', apply);
    apply();
  }

  /* ==========================================================================
     AVALIAÇÕES (selo + pop-up). A seção "Avaliações (selo e pop-up)" gera tudo
     num <template>; aqui vai para o lugar reservado abaixo do título.
     ========================================================================== */
  function mountReviews(root) {
    const slot = $('[data-reviews-slot]', root);
    if (!slot) return;
    const src = document.querySelector('template[data-reviews-source]');
    slot.innerHTML = '';
    if (!src) return;
    slot.appendChild(src.content.cloneNode(true));
    const box = $('[data-reviews]', slot);
    if (box) initReviewsBadge(box);
  }

  function initReviewsBadge(box) {
    const dlg = $('[data-rvm]', box);
    const list = $('[data-rv-list]', box);
    const more = $('[data-rv-more]', box);
    const PAGE = 10;
    let filter = 'all';
    let shown = PAGE;
    const fmt = (n) => Number(n).toLocaleString('en-US');
    $$('[data-rv-num]', box).forEach((el) => { el.textContent = el.textContent.replace(/\d+/, (d) => fmt(d)); });
    const paint = () => {
      const items = $$('[data-rv-item]', list);
      const match = items.filter((it) => filter === 'all' || it.dataset.source === filter);
      items.forEach((it) => { it.hidden = true; });
      match.slice(0, shown).forEach((it) => { it.hidden = false; });
      if (more) more.hidden = match.length <= shown;
    };
    $$('[data-rv-tab]', box).forEach((tab) => on(tab, 'click', () => {
      $$('[data-rv-tab]', box).forEach((x) => x.classList.toggle('is-on', x === tab));
      filter = tab.dataset.rvTab;
      shown = PAGE;
      const avg = $('[data-rv-avg]', box); if (avg) avg.textContent = tab.dataset.avg;
      const cnt = $('[data-rv-count]', box); if (cnt) cnt.textContent = '(' + fmt(tab.dataset.count) + ')';
      const st = $('[data-rv-stars]', box); if (st) st.style.setProperty('--pct', (parseFloat(tab.dataset.avg) * 20) + '%');
      list.scrollTop = 0;
      paint();
    }));
    on(more, 'click', () => { shown += PAGE; paint(); });
    on($('[data-rvb-open]', box), 'click', () => { if (dlg && dlg.showModal) { dlg.showModal(); lock(); } });
    on($('[data-rvm-close]', box), 'click', () => dlg.close());
    on(dlg, 'close', unlock);
    on(dlg, 'click', (e) => { if (e.target === dlg) dlg.close(); });
    paint();
  }

  /* ==========================================================================
     TABELA DE MEDIDAS
     ========================================================================== */
  function initSizePanel() {
    const panel = $('[data-size-panel]');
    if (!panel) return;
    const open = () => { panel.classList.add('is-open'); panel.setAttribute('aria-hidden', 'false'); lock(); };
    const close = () => { panel.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true'); unlock(); };
    on(document, 'click', (e) => {
      if (e.target.closest('[data-size-open]')) { e.preventDefault(); open(); }
      if (e.target.closest('[data-size-close]')) close();
    });
    on(document, 'keydown', (e) => { if (e.key === 'Escape' && panel.classList.contains('is-open')) close(); });
  }

  /* ==========================================================================
     COLEÇÃO: filtros
     ========================================================================== */
  function initFacets() {
    const facets = $('[data-facets]');
    if (!facets) return;
    const form = $('[data-facets-form]', facets);
    $$('[data-facet-auto]', facets).forEach((c) => on(c, 'change', () => {
      const lbl = c.closest('.facet__opt'); if (lbl) lbl.classList.toggle('is-on', c.checked);
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    }));
    if (form) on(form, 'submit', () => {
      $$('input', form).forEach((i) => { if ((i.type === 'number' || i.type === 'hidden') && !i.value) i.disabled = true; });
    });
    const open = (mode) => {
      facets.classList.remove('show-sort', 'show-filters');
      facets.classList.add('is-open', 'show-' + mode);
      if (mode === 'sort') { const d = $('[data-facet="sort"]', facets); if (d) d.open = true; }
      lock();
    };
    const close = () => { facets.classList.remove('is-open'); unlock(); };
    $$('[data-facets-open]').forEach((b) => on(b, 'click', () => open(b.dataset.facetsOpen)));
    $$('[data-facets-close]').forEach((b) => on(b, 'click', close));
  }

  /* ==========================================================================
     RECOMENDAÇÕES
     ========================================================================== */
  function initRecs() {
    $$('[data-recs]').forEach(async (box) => {
      if (box.children.length) return;
      try {
        const r = await fetch(box.dataset.url);
        const html = await r.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const src = $('[data-recs]', doc);
        if (src && src.innerHTML.trim()) { box.innerHTML = src.innerHTML; Wish.paint(); }
      } catch (e) { /* */ }
    });
  }

  /* ==========================================================================
     LISTA DE DESEJOS
     ========================================================================== */
  const Wish = {
    key: 'phab_wishlist',
    get() { try { const v = JSON.parse(localStorage.getItem(this.key) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } },
    set(v) { try { localStorage.setItem(this.key, JSON.stringify(v)); } catch (e) { /* */ } },
    paint() {
      const w = this.get();
      $$('[data-wish]').forEach((b) => b.setAttribute('aria-pressed', w.includes(b.dataset.wish) ? 'true' : 'false'));
      $$('[data-wish-count]').forEach((b) => { b.textContent = w.length; b.hidden = !w.length; });
    },
    init() {
      on(document, 'click', (e) => {
        const b = e.target.closest('[data-wish]');
        if (!b) return;
        e.preventDefault();
        const w = this.get(); const h = b.dataset.wish;
        const i = w.indexOf(h);
        if (i > -1) w.splice(i, 1); else w.push(h);
        this.set(w); this.paint();
      });
      this.paint();
      const grid = $('[data-wishlist-grid]');
      if (grid) this.renderPage(grid);
    },
    async renderPage(grid) {
      const w = this.get();
      const empty = $('[data-wishlist-empty]');
      if (!grid._bound) {
        grid._bound = true;
        on(grid, 'click', (e) => { if (e.target.closest('[data-wish]')) setTimeout(() => this.renderPage(grid), 50); });
      }
      if (!w.length) {
        grid.innerHTML = '';
        if (empty) empty.hidden = false;
        return;
      }
      const cards = await Promise.all(w.map(async (h) => {
        try {
          const p = await (await fetch(P.routes.root + 'products/' + h + '.js')).json();
          const img = p.featured_image ? '<img class="card__img" src="' + p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=600" alt="" loading="lazy">' : '';
          const sale = p.compare_at_price > p.price;
          return '<div class="card"><div class="card__media"><button type="button" class="wishbtn" data-wish="' + p.handle + '" aria-pressed="true" aria-label="Remove">♥</button><a class="card__link" href="' + p.url + '">' + img + '</a></div><div class="card__body"><a class="card__name" href="' + p.url + '">' + escapeHtml(p.title) + '</a><div class="price' + (sale ? ' price--sale' : '') + '"><span class="price__now">' + formatMoney(p.price) + '</span>' + (sale ? '<span class="price__was">' + formatMoney(p.compare_at_price) + '</span>' : '') + '</div><div class="card__brand">' + escapeHtml(p.vendor || '') + '</div></div></div>';
        } catch (e) { return ''; }
      }));
      grid.innerHTML = cards.join('');
    }
  };

  /* ==========================================================================
     INICIALIZAÇÃO
     ========================================================================== */
  function init() {
    initTicker();
    initOfferBar();
    initHeader();
    initCarousels();
    initHero();
    initReviews();
    Cart.init();
    $$('[data-product]').forEach(initProduct);
    initSizePanel();
    initFacets();
    initRecs();
    Wish.init();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // editor de temas: reinicializa seções ao editar
  document.addEventListener('shopify:section:load', (e) => {
    // editor: ao mexer na seção "Patches", remonta a caixa no produto
    if (e.target.querySelector('template[data-patch-source]')) $$('[data-product]').forEach(mountPatches);
    if (e.target.querySelector('template[data-reviews-source]')) $$('[data-product]').forEach(mountReviews);
    initCarousels(e.target);
    initTicker();
    initOfferBar();
    initHero();
    initReviews();
    $$('[data-product]', e.target).forEach(initProduct);
  });

  window.PHAB.Cart = Cart;
  window.PHAB.formatMoney = formatMoney;
})();
